import { IAdvancedRole } from '../models/advancedRole.model';

import { IBaseAction, IErrorAction } from '../../../../store/types/base.state';

export const RolesActionValues = {
  GET_ROLE: 'GET_ROLE',
  GET_ROLE_FAILED: 'GET_ROLE_FAILED',
  GET_ROLE_SUCCESS: 'GET_ROLE_SUCCESS',
  UPDATE_ROLE: 'UPDATE_ROLE',
  UPDATE_ROLE_SUCCESS: 'UPDATE_ROLE_SUCCESS',
  UPDATE_ROLE_FAILED: 'UPDATE_ROLE_FAILED',
  SET_ROLE: 'SET_ROLE',
  SET_ROLE_SUCCESS: 'SET_ROLE_SUCCESS',
  SET_ROLE_FAILED: 'SET_ROLE_FAILED',
} as const;
export type TRolesActionTypes = (typeof RolesActionValues)[keyof typeof RolesActionValues];

export interface IRolesGetAction extends IBaseAction {
  type: typeof RolesActionValues.GET_ROLE;
}

export interface IRolesGetSuccessAction extends IBaseAction {
  type: typeof RolesActionValues.GET_ROLE_SUCCESS;
  role: IAdvancedRole;
}
export interface IRolesGetFailedAction extends IErrorAction {
  type: typeof RolesActionValues.GET_ROLE_FAILED;
}

export interface IRolesUpdateAction extends IBaseAction {
  type: typeof RolesActionValues.UPDATE_ROLE;
}

export interface IRolesUpdateSuccessAction extends IBaseAction {
  type: typeof RolesActionValues.UPDATE_ROLE_SUCCESS;
  metadata: any;
}
export interface IRolesUpdateFailedAction extends IErrorAction {
  type: typeof RolesActionValues.UPDATE_ROLE_FAILED;
}

export interface IRolesSetAction extends IBaseAction {
  type: typeof RolesActionValues.SET_ROLE;
}

export interface IRolesSetSuccessAction extends IBaseAction {
  type: typeof RolesActionValues.SET_ROLE_SUCCESS;
  role: any;
}
export interface IRolesSetFailedAction extends IErrorAction {
  type: typeof RolesActionValues.SET_ROLE_FAILED;
}

export type TRolesActions =
  | IRolesGetAction
  | IRolesGetSuccessAction
  | IRolesGetFailedAction
  | IRolesUpdateAction
  | IRolesUpdateSuccessAction
  | IRolesUpdateFailedAction
  | IRolesSetAction
  | IRolesSetSuccessAction
  | IRolesSetFailedAction;
